import { createContext, type ReactNode, useContext, useEffect, useMemo, useState } from "react";

type CrumbTitleCtx = { title: string | null; setTitle: (t: string | null) => void };

const Ctx = createContext<CrumbTitleCtx>({ title: null, setTitle: () => {} });

/** Shares a detail page's entity name with the Breadcrumb (which renders above the Outlet). */
export function CrumbTitleProvider({ children }: { children: ReactNode }) {
  const [title, setTitle] = useState<string | null>(null);
  const value = useMemo(() => ({ title, setTitle }), [title]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

/** Read the current detail-crumb title (used by the Breadcrumb for the last segment). */
export function useCrumbTitle(): string | null {
  return useContext(Ctx).title;
}

/** Set the last breadcrumb label to the current entity name; cleared on unmount. */
export function useSetCrumbTitle(title: string | null | undefined): void {
  const { setTitle } = useContext(Ctx);
  useEffect(() => {
    setTitle(title ?? null);
    return () => setTitle(null);
  }, [title, setTitle]);
}
